import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSecAadhaar, setSecDl, setSecPassport, setStep, setCustomer, setSecDetails } from "../../../Reducer/customerSlice";
import { getCookie, reloadWindow, parseDob, canUploadKyc } from "../../../Helpers/Utils";
import NextPrev from "../../../Helpers/Components/NextPrev";
import White from "../../../Assets/images/white-bg.avif"
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";
import moment from "moment";
import DatePicker from "react-multi-date-picker";
import Compressor from 'compressorjs';
import Modal from "../../../Helpers/Components/Modal";
import DateObject from "react-date-object";

const KYC = (props) => {
    const person = getCookie('person')
    const secDl = useSelector(state => state?.customer?.secDl)
    const secAadhaar = useSelector(state => state?.customer?.secAadhaar)
    const secPassport = useSelector(state => state?.customer?.secPassport)
    const [loading, setLoading] = useState(false)
    const [link, setLink] = useState("")
    const [openModal, setOpenModal] = useState(false)
    const customer = useSelector(state => state?.customer?.customer)
    const secDetails = useSelector(state => state?.customer?.secDetails)
    const dispatch = useDispatch()
    const copy = () => navigator.clipboard.writeText(link);
    const [buttonHide, setButtonHide] = useState(true);
    const setSteps = () => dispatch(setStep(5))
    const maxDobDate = new Date();
    maxDobDate.setFullYear(maxDobDate.getFullYear() - 18);
    const maxDateObject = new DateObject(maxDobDate);
    const handleNext = async () => {
        if (secDetails?.name || secDetails?.dob || ((secDl?.dl || secDl?.dlPhoto || secDl?.dlBackPhoto) && (!secDl?.dlStatus || (secDl?.dl_photo && typeof secDl?.dl_photo !== "string") || (secDl?.dl_back_photo && typeof secDl?.dl_back_photo !== "string"))) || secAadhaar?.aadhaar || secAadhaar?.aadhaarBackPhoto || secAadhaar?.aadhaarPhoto || secPassport?.passport || secPassport?.passportPhoto || secPassport?.passportPhoto1 || secPassport?.passportPhoto2) {
            setLoading(true)
            let otherKyc = []
            if ((secDl?.dl || secDl?.dlPhoto || secDl?.dlBackPhoto) && (!secDl?.dlStatus || (secDl?.dl_photo && typeof secDl?.dl_photo !== "string") || (secDl?.dl_back_photo && typeof secDl?.dl_back_photo !== "string"))) {
                otherKyc.push({ ...(secDl?.dl ? { type: 'dl', ...(secDl?.dl ? { id: secDl?.dl } : {}), status: secDl?.dlStatus, ...(secDl?.dlPhoto && typeof secDl?.dl_photo === 'string' ? { dl_photo: secDl?.dl_photo } : {}), ...(secDl?.dlBackPhoto && typeof secDl?.dl_back_photo === 'string' ? { dl_back_photo: secDl?.dl_back_photo } : {}), ...(secDl?.dlDate || secDl?.dob ? { detail: { ...(secDl?.dlDate ? { validTo: moment(new Date(secDl?.dlDate))?.format("DD/MM/YYYY") } : {}), ...(secDl?.dob ? { dob: moment(new Date(secDl?.dob))?.format("DD/MM/YYYY") } : {}) } } : {}) } : {}) })
            }
            if (secAadhaar?.aadhaar || secAadhaar?.aadhaarBackPhoto || secAadhaar?.aadhaarPhoto) {
                otherKyc.push({ ...(secAadhaar?.aadhaar ? { type: 'aadhaar', ...(secAadhaar?.aadhaar ? { id: secAadhaar?.aadhaar } : {}), status: secAadhaar?.aadhaarStatus, ...(secAadhaar?.aadhaarPhoto && typeof secAadhaar?.aadhaar_photo === 'string' ? { aadhaar_photo: secAadhaar?.aadhaar_photo } : {}), ...(secAadhaar?.aadhaarBackPhoto && typeof secAadhaar?.aadhaar_back_photo === 'string' ? { aadhaar_back_photo: secAadhaar?.aadhaar_back_photo } : {}) } : {}) })
            }
            if (secPassport?.passport || secPassport?.passportPhoto || secPassport?.passportPhoto1 || secPassport?.passportPhoto2) {
                otherKyc.push({ ...(secPassport?.passport ? { type: 'passport', ...(secPassport?.passport ? { id: secPassport?.passport } : {}), status: secPassport?.passportStatus, ...(secPassport?.passportPhoto && typeof secPassport?.passport_photo === 'string' ? { passport_photo: secPassport?.passport_photo } : {}), ...(secPassport?.passportPhoto1 && typeof secPassport?.passport_photo_1 === 'string' ? { passport_photo_1: secPassport?.passport_photo_1 } : {}), ...(secPassport?.passportPhoto2 && typeof secPassport?.passport_photo_2 === 'string' ? { passport_photo_2: secPassport?.passport_photo_2 } : {}), ...(secPassport?.passportDate || secPassport?.passportName || secPassport?.dob ? { detail: { ...(secPassport?.passportDate ? { passportDate: moment(new Date(secPassport?.passportDate))?.format("DD-MM-YYYY") } : {}), ...(secPassport?.passportName ? { passportName: secPassport?.passportName } : {}), ...(secPassport?.dob ? { dob: moment(new Date(secPassport?.dob)).format("DD-MM-YYYY") } : {}), } } : {}) } : {}) })
            }
            const response = await Handler({
                method: 'patch', url: `/customer/other/kyc/update/${props?.customerId}`,
                data: {
                    otherKyc,
                    ...(typeof secAadhaar?.aadhaar_photo !== 'string' ? { aadhaar_photo: secAadhaar?.aadhaar_photo } : {}),
                    ...(typeof secAadhaar?.aadhaar_back_photo !== 'string' ? { aadhaar_back_photo: secAadhaar?.aadhaar_back_photo } : {}),
                    ...(typeof secDl?.dl_back_photo !== 'string' ? { dl_back_photo: secDl?.dl_back_photo } : {}),
                    ...(typeof secDl?.dl_photo !== 'string' ? { dl_photo: secDl?.dl_photo } : {}),
                    ...(typeof secPassport?.passport_photo !== 'string' ? { passport_photo: secPassport?.passport_photo } : {}),
                    ...(typeof secPassport?.passport_photo_1 !== 'string' ? { passport_photo_1: secPassport?.passport_photo_1 } : {}),
                    ...(typeof secPassport?.passport_photo_2 !== 'string' ? { passport_photo_2: secPassport?.passport_photo_2 } : {}),
                    ...(secDetails?.name || secDetails?.dob ? { secDetails: { ...(secDetails?.name ? { name: secDetails?.name } : {}), ...(secDetails?.dob ? { dob: secDetails?.dob } : {}) } } : {})
                }, headers: { 'Content-Type': 'multipart/form-data' }
            })
            if (response?.success) {
                props?.page?.other ? dispatch(setStep(7)) : dispatch(setStep(8))
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        } else {
            if (customer?.secPhoto) {
                props?.page?.other ? dispatch(setStep(7)) : dispatch(setStep(8))
            } else {
                setOpenModal(true)
            }
        }
    }
    const goToNext = () => {
        props?.setPage((prev) => ({ ...prev, kyc: false }))
        props?.page?.other ? dispatch(setStep(7)) : dispatch(setStep(8))
    }
    const checkFileSize = async (file, fieldName, previewKey) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            if (previewKey === 'secDlPhoto' || previewKey === 'secDlBackPhoto') {
                dispatch(setSecDl({
                    [fieldName]: file,
                    [`${previewKey === "secDlPhoto" ? "dlPhoto" : "dlBackPhoto"}`]: URL.createObjectURL(file),
                }));
            } else if (previewKey === 'secAadhaarPhoto' || previewKey === 'secAadhaarBackPhoto') {
                dispatch(setSecAadhaar({
                    [fieldName]: file,
                    [`${previewKey === "secAadhaarPhoto" ? "aadhaarPhoto" : "aadhaarBackPhoto"}`]: URL.createObjectURL(file),
                }));
            } else if (previewKey === 'secPassportPhoto' || previewKey === 'secPassportPhoto1' || previewKey === 'secPassportPhoto2') {
                dispatch(setSecPassport({
                    [fieldName]: file,
                    [`${previewKey === 'secPassportPhoto' ? "passportPhoto" : previewKey === "secPassportPhoto1" ? "passportPhoto1" : "passportPhoto2"}`]: URL.createObjectURL(file),
                }));
            } else if (previewKey === "secPhoto") {
                const formData = new FormData()
                formData?.append('photo', file)
                const response = await Handler({ data: formData, url: `/customer/details/secimage/${props?.customerId}`, method: 'patch', headers: { 'Content-Type': 'multipart/form-data' } })
                if (response?.success) {
                    dispatch(setCustomer({ secPhoto: URL.createObjectURL(file) }))
                } else {
                    toast.error("Unable to upload image")
                }
                setLoading(false)
            }
        }
    };
    const compressImage = (file, fieldName, previewKey) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result, fieldName, previewKey);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event, previewKey) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0], [event.target.name], previewKey);
        }
    };
    const handleProofChange = (event, name) => {
        if (name === "secDl") {
            dispatch(setSecDl({ [event.target.name]: event.target.value }))
        } else if (name === "secAadhaar") {
            dispatch(setSecAadhaar({ [event.target.name]: event.target.value }))
        } else if (name === "secPassport") {
            dispatch(setSecPassport({ [event.target.name]: event.target.value }))
        }
    }
    const verifySecDl = async () => {
        if (!secDl?.dl) {
            toast.error("Driving license is required")
        } else if (!secDl?.dl_photo) {
            toast.error("Driving license Photo is required")
        } else if (!secDl?.dl_back_photo) {
            toast.error("Front and back Driving license Photo is required")
        } else {
            setLoading(true)
            const formData = new FormData();
            formData?.append("dl", secDl?.dl);
            formData.append("dob", secDl?.dob ? moment(new Date(secDl?.dob))?.format("DD-MM-YYYY") : moment(new Date(maxDobDate))?.format("DD-MM-YYYY"))
            formData.append('dl_photo', secDl?.dl_photo);
            formData.append('dl_back_photo', secDl?.dl_back_photo);
            const response = await Handler({ method: "patch", data: formData, url: `/customer/other/dl/verify/${props?.customerId}`, headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                toast.success(response?.message)
                dispatch(setSecDl({ dlStatus: true, detail: { dob: response?.data?.dob }, dlDate: response?.data?.validTo, dlName: response?.data?.name, dl_photo: response?.data?.dl_photo, dl_back_photo: response?.data?.dl_back_photo }))
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }
    const verifySecPassport = async () => {
        if (!secPassport?.passport) {
            toast.error("Passport Number is required")
        } else if (!secPassport?.passportName) {
            toast.error("Name in Passport is required")
        } else if (!secPassport?.passportDate) {
            toast.error("Valid Upto is required")
        } else if (!secPassport?.passport_photo) {
            toast.error("Passport Photo is required")
        } else if (!secPassport?.passport_photo_1) {
            toast.error("Three Pages of Passport Photo is required")
        } else if (!secPassport?.passport_photo_2) {
            toast.error("Three Pages of Passport Photo is required")
        } else {
            const formData = new FormData();
            formData.append("passport", secPassport?.passport);
            formData.append("passportName", secPassport?.passportName);
            formData.append("passportDate", moment(new Date(secPassport?.passportDate)).format("DD-MM-YYYY"));
            formData.append("dob", secPassport?.dob ? moment(new Date(secPassport?.dob))?.format("DD-MM-YYYY") : moment(new Date(maxDobDate))?.format("DD-MM-YYYY"));
            formData.append('passport_photo', secPassport?.passport_photo);
            formData.append('passport_photo_1', secPassport?.passport_photo_1);
            formData.append('passport_photo_2', secPassport?.passport_photo_2);
            setLoading(true)
            const response = await Handler({ method: "patch", url: `/customer/other/passport/verify/${props?.customerId}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                toast.success(response?.message);
                dispatch(setSecPassport({ passportStatus: true, passport_photo: response?.data?.passport_photo, passport_photo_1: response?.data?.passport_photo_1, passport_photo_2: response?.data?.passport_photo_2 }))
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }
    const getLink = async () => {
        if (secAadhaar?.aadhaar?.length !== 12) {
            toast.error("Invalid aadhaar number")
        } else if (!secAadhaar?.aadhaarPhoto || !secAadhaar?.aadhaarBackPhoto) {
            toast.error("Aadhar photos are required")
        } else {
            setLoading(true)
            const formData = new FormData()
            formData.append("aadhaar", secAadhaar?.aadhaar)
            formData.append("aadhaar_photo", secAadhaar?.aadhaar_photo)
            formData.append("aadhaar_back_photo", secAadhaar?.aadhaar_back_photo)
            const response = await Handler({ method: 'patch', url: `/customer/other/aadhaar/${props?.customerId}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                dispatch(setSecAadhaar({ aadhaar_photo: response?.data?.aadhaar_photo, aadhaar_back_photo: response?.data?.aadhaar_back_photo }))
                setButtonHide(false);
                window.DigiboostSdk({
                    gateway: "production",
                    token: response?.data?.token,
                    selector: "#digilocker-button",
                    onSuccess: async function (data) {
                        const fetchData = await Handler({
                            method: "patch",
                            url: `/customer/other/aadhaar/verify/${props?.customerId}`,
                            data: { clientId: response?.data?.clientId }
                        });
                        if (fetchData?.success) {
                            toast.success("Aadhaar verification successful");
                        } else {
                            toast.error("Aadhaar verification failed");
                        }
                        setTimeout(() => {
                            reloadWindow()
                        }, 2000);
                    },

                    onFailure: function (error) {
                        console.log("Verification failed:", error);
                    }
                });
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }
    return (
        <React.Fragment>
            <div className={`${loading ? "cover" : ""} card p-3 mb-3`}>
                <h6 className="fw-bold">Second Customer Profile Details</h6>
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-5 col-xl-5">
                        <div className="main-div mb-3">
                            <div className="btn-div">
                                {loading ? "" : <label htmlFor='secPhoto' className="me-2 upload-btn">Upload</label>}
                                <button className="btn-warning btn btn-sm" onClick={() => { if (customer?.secPhoto) { props?.setChosen(customer?.secPhoto); props?.setProof(true) } }}>View</button>
                            </div>
                            <img src={customer?.secPhoto || White} alt="Sec Profile" className="kycPhotoImg" />
                        </div>
                        <input type="file" accept="image/*" className="d-none" name="secPhoto" id='secPhoto' disabled={loading} onChange={(event) => { handleImage(event, "secPhoto") }} />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-7 col-xl-4 mt-3 mt-md-0">
                        <div className="mb-3">
                            <label htmlFor="secName" className="form-label"> Name </label>
                            <div className="input-group mb-3">
                                <input autoComplete="off" disabled={loading} id="secName" type="text" name="secName" value={secDetails?.name || ""} onChange={(e) => dispatch(setSecDetails({ name: e.target.value }))} className="form-control input-theme text-uppercase" />
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="secDob" className="form-label"> DOB </label>
                            <div className="input-group datepicker-top mb-3">
                                <DatePicker
                                    className="input-theme"
                                    value={secDetails?.dlStatus ? (parseDob(secDetails?.detail?.dob) || "") : secDetails?.dob ? new Date(secDetails?.dob) : undefined}
                                    onChange={(e) => { dispatch(setSecDetails({ dob: new Date(e)?.toString() })) }}
                                    format="DD-MM-YYYY"
                                    disabled={loading}
                                    maxDate={maxDobDate}
                                    currentDate={maxDateObject}
                                    onOpenPickNewDate={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${loading ? "cover" : ""} card p-3 mb-3`}>
                <h6 className="fw-bold">DL Details</h6>
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-7 col-xl-8">
                        <div className="row">
                            <div className="col-lg-12 col-xl-6">
                                <div className="main-div mt-3">
                                    <div className="btn-div">
                                        {canUploadKyc(person, secDl?.dlStatus, secDl?.dl_photo) ? <label htmlFor="dl_photo" className="me-2 upload-btn">Upload</label> : ""}
                                        <button className="btn-warning btn btn-sm" onClick={() => { if (secDl?.dlPhoto) { props?.setChosen(secDl?.dlPhoto); props?.setProof(true) } }}>View</button>
                                    </div>
                                    <input type="file" accept="image/*" className="d-none" name="dl_photo" id="dl_photo" onChange={(e) => handleImage(e, "secDlPhoto")} disabled={loading} />
                                    <img src={secDl?.dlPhoto || White} alt="Driving License" className="kycPhotoImg" />
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-6">
                                <div className="main-div mt-3">
                                    <div className="btn-div">
                                        {canUploadKyc(person, secDl?.dlStatus, secDl?.dl_back_photo) ? <label htmlFor="dl_back_photo" className="me-2 upload-btn">Upload</label> : ""}
                                        <button className="btn-warning btn btn-sm" onClick={() => { if (secDl?.dlBackPhoto) { props?.setChosen(secDl?.dlBackPhoto); props?.setProof(true) } }}>View</button>
                                    </div>
                                    <input type="file" accept="image/*" className="d-none" name="dl_back_photo" id="dl_back_photo" onChange={(e) => handleImage(e, "secDlBackPhoto")} disabled={loading} />
                                    <img src={secDl?.dlBackPhoto || White} alt="Driving License" className="kycPhotoImg" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-5 col-xl-4 mt-3 mt-md-0">
                        <div className="mb-3">
                            <label htmlFor="dl" className="form-label"> DL No </label>
                            <div className="input-group mb-3">
                                <input autoComplete="off" maxLength={16} disabled={loading || secDl?.dlStatus} id="dl" type="text" name="dl" value={secDl?.dl || ""} onChange={(e) => handleProofChange(e, "secDl")} className="form-control input-theme text-uppercase" />
                                {secDl?.dlStatus ? <span className="input-group-text" id="basic-addon2"><i className="fa-solid fa-circle-check" style={{ color: 'green' }}></i></span> : ""}
                            </div>
                        </div>
                        {
                            secDl?.dlName ?
                                <div className="d-xl-none d-block mb-3">
                                    <div className="mb-3">
                                        <label htmlFor="dlName" className="form-label"> DL Name </label>
                                        <input autoComplete="off" disabled id="dlName" type="text" name="dlName" value={secDl?.dlName || ""} className="form-control input-theme text-uppercase" />
                                    </div>
                                </div> : ""
                        }
                        <div className="mb-3">
                            <label htmlFor="dlDate" className="form-label"> DL Valid Upto </label>
                            <div className=" datepicker-top">
                                <DatePicker
                                    className="input-theme"
                                    value={secDl?.dlDate ? new Date(secDl?.dlDate) : undefined}
                                    onChange={(e) => { dispatch(setSecDl({ dlDate: e ? new Date(e) : "" })) }}
                                    format="DD-MM-YYYY"
                                    minDate={new Date(new Date()?.setDate(new Date()?.getDate() + 1))}
                                    disabled={loading || secDl?.dlStatus}
                                    onOpenPickNewDate={false}
                                />
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="dob" className="form-label"> DOB </label>
                            <div className=" datepicker-top">
                                <DatePicker
                                    className="input-theme"
                                    value={secDl?.dob && parseDob(secDl?.dob) ? parseDob(secDl?.dob) : (secDl?.dob === "Invalid Date" && secDetails?.dob ? new Date(secDetails?.dob) : undefined)}
                                    onChange={(e) => { dispatch(setSecDl({ dob: new Date(e) })) }}
                                    format="DD-MM-YYYY"
                                    disabled={loading || secDl?.dlStatus}
                                    maxDate={maxDobDate}
                                    defaultPickerValue={maxDobDate}
                                    currentDate={maxDateObject}
                                />
                            </div>
                        </div>
                        {
                            !secDl?.dlStatus ? <button className="btn btn-sm btn-success" disabled={loading} onClick={verifySecDl}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Verify"}</button> : ""
                        }
                        {
                            secDl?.dlStatus && person === "admin" ? <button className="btn btn-sm btn-success" disabled={loading} onClick={() => { dispatch(setSecDl({ dlStatus: false })) }}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Update"}</button> : ""
                        }
                    </div>
                </div>
            </div>
            <div className={`${loading ? "cover" : ""} card p-3 mb-3`}>
                <h6 className="fw-bold">Aadhaar Details</h6>
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-7 col-xl-8">
                        <div className="row">
                            <div className="col-lg-12 col-xl-6">
                                <div className="main-div mt-3">
                                    <div className="btn-div">
                                    {canUploadKyc(person, secAadhaar?.aadhaarStatus, secAadhaar?.aadhaar_photo) ? <label htmlFor="aadhaar_photo" className="me-2 upload-btn">Upload</label> : ""}
                                    <button className="btn-warning btn btn-sm" onClick={() => { if (secAadhaar?.aadhaarPhoto) { props?.setChosen(secAadhaar?.aadhaarPhoto); props?.setProof(true) } }}>View</button>
                                    </div>
                                    <input type="file" accept="image/*" className="d-none" name="aadhaar_photo" id="aadhaar_photo" onChange={(e) => handleImage(e, "secAadhaarPhoto")} />
                                    <img src={secAadhaar?.aadhaarPhoto || White} alt="Aadhaar" className="kycPhotoImg" />
                                </div>

                            </div>
                            <div className="col-lg-12 col-xl-6">
                                <div className="main-div mt-3">
                                    <div className="btn-div">
                                    {canUploadKyc(person, secAadhaar?.aadhaarStatus, secAadhaar?.aadhaar_back_photo) ? <label htmlFor="aadhaar_back_photo" className="me-2 upload-btn">Upload</label> : ""}
                                    <button className="btn-warning btn btn-sm" onClick={() => { if (secAadhaar?.aadhaarBackPhoto) { props?.setChosen(secAadhaar?.aadhaarBackPhoto); props?.setProof(true) } }}>View</button>
                                    </div>
                                    <input type="file" accept="image/*" className="d-none" name="aadhaar_back_photo" id="aadhaar_back_photo" onChange={(e) => handleImage(e, "secAadhaarBackPhoto")} />
                                    <img src={secAadhaar?.aadhaarBackPhoto || White} alt="Aadhaar" className="kycPhotoImg" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-5 col-xl-4 mt-3 mt-md-0">
                        <div className="mb-3">
                            <label htmlFor="aadhaar" className="form-label"> Aadhaar </label>
                            <div className="input-group mb-3">
                                <input autoComplete="off" maxLength={12} disabled={loading || secAadhaar?.aadhaarStatus || link} id="aadhaar" type="text" name="aadhaar" value={link ? link : (secAadhaar?.aadhaar || "")} onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleProofChange(e, "secAadhaar") } }} className="form-control input-theme text-uppercase" />
                                {
                                    secAadhaar?.aadhaarStatus ? <span className="input-group-text" id="basic-addon2"><i className="fa-solid fa-circle-check" style={{ color: 'green' }}></i></span> :
                                        (buttonHide ? <button className="btn btn-primary" onClick={getLink} disabled={loading}>{loading ? "Generating..." : "Generate Link"}</button> : "")
                                }
                                <div id="digilocker-button" ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${loading ? "cover" : ""} card p-3 mb-3`}>
                <h6 className="fw-bold">Passport Details</h6>
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-7 col-xl-8">
                        <div className="row">
                            <div className="col-lg-12 col-xl-6">
                                <div className="main-div mt-3">
                                    <div className="btn-div">
                                    {canUploadKyc(person, secPassport?.passportStatus, secPassport?.passport_photo) ? <label htmlFor="passport_photo" className="me-2 upload-btn">Upload</label> : ""}
                                    <button className="btn-warning btn btn-sm" onClick={() => { if (secPassport?.passportPhoto) { props?.setChosen(secPassport?.passportPhoto); props?.setProof(true) } }}>View</button>
                                    </div>
                                    <input type="file" accept="image/*" className="d-none" name="passport_photo" id="passport_photo" onChange={(e) => handleImage(e, "secPassportPhoto")} />
                                    <img src={secPassport?.passportPhoto || White} alt="Passport" className="kycPhotoImg" />
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-6">
                                <div className="main-div mt-3">
                                    <div className="btn-div">
                                    {canUploadKyc(person, secPassport?.passportStatus, secPassport?.passport_photo_1) ? <label htmlFor="passport_photo_1" className="me-2 upload-btn">Upload</label> : ""}
                                    <button className="btn-warning btn btn-sm" onClick={() => { if (secPassport?.passportPhoto1) { props?.setChosen(secPassport?.passportPhoto1); props?.setProof(true) } }}>View</button>
                                    </div>
                                    <input type="file" accept="image/*" className="d-none" name="passport_photo_1" id="passport_photo_1" onChange={(e) => handleImage(e, "secPassportPhoto1")} />
                                    <img src={secPassport?.passportPhoto1 || White} alt="Passport" className="kycPhotoImg" />
                                </div>
                            </div>
                            <div className="col-lg-12 col-xl-6">
                                <div className="main-div mt-3">
                                    <div className="btn-div">
                                    {canUploadKyc(person, secPassport?.passportStatus, secPassport?.passport_photo_2) ? <label htmlFor="passport_photo_2" className="me-2 upload-btn">Upload</label> : ""}
                                    <button className="btn-warning btn btn-sm" onClick={() => { if (secPassport?.passportPhoto2) { props?.setChosen(secPassport?.passportPhoto2); props?.setProof(true) } }}>View</button>
                                    </div>
                                    <input type="file" accept="image/*" className="d-none" name="passport_photo_2" id="passport_photo_2" onChange={(e) => handleImage(e, "secPassportPhoto2")} />
                                    <img src={secPassport?.passportPhoto2 || White} alt="Passport" className="kycPhotoImg" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-5 col-xl-4 mt-3 mt-md-0">
                        <div className="mb-3">
                            <label htmlFor="passport" className="form-label"> Passport </label>
                            <div className="input-group mb-3">
                                <input autoComplete="off" disabled={loading || secPassport?.passportStatus} id="passport" type="text" name="passport" value={secPassport?.passport || ""} onChange={(e) => handleProofChange(e, "secPassport")} className="form-control input-theme text-uppercase" />
                                {secPassport?.passportStatus ? <span className="input-group-text" id="basic-addon2"><i className="fa-solid fa-circle-check" style={{ color: 'green' }}></i></span> : ""}
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="passportName" className="form-label"> Passport Name </label>
                            <input autoComplete="off" disabled={loading || secPassport?.passportStatus} id="passportName" type="text" name="passportName" value={secPassport?.passportName || ""} onChange={(e) => handleProofChange(e, "secPassport")} className="form-control input-theme text-uppercase" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="passportDate" className="form-label"> Passport Valid Upto </label>
                            <div className=" datepicker-top">
                                <DatePicker
                                    className="input-theme"
                                    value={secPassport?.passportDate ? new Date(secPassport?.passportDate) : undefined}
                                    onChange={(e) => { dispatch(setSecPassport({ passportDate: e ? new Date(e)?.toString() : "" })) }}
                                    format="DD-MM-YYYY"
                                    minDate={new Date(new Date()?.setDate(new Date()?.getDate() + 1))}
                                    disabled={loading || secPassport?.passportStatus}
                                    onOpenPickNewDate={false}
                                />
                            </div>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="dob" className="form-label"> DOB </label>
                            <div className=" datepicker-top">
                                <DatePicker
                                    className="input-theme"
                                    value={secPassport?.dob ? new Date(secPassport?.dob) : undefined}
                                    onChange={(e) => { dispatch(setSecPassport({ dob: new Date(e)?.toString() })) }}
                                    format="DD-MM-YYYY"
                                    disabled={loading || secPassport?.passportStatus}
                                    maxDate={maxDobDate}
                                    defaultPickerValue={maxDobDate}
                                    onOpenPickNewDate={false}
                                    currentDate={maxDateObject}
                                /></div>
                        </div>
                        {
                            !secPassport?.passportStatus ? <button className="btn btn-sm btn-success" disabled={loading} onClick={verifySecPassport}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Verify"}</button> : ""
                        }
                        {
                            secPassport?.passportStatus && person === "admin" ? <button className="btn btn-sm btn-success" disabled={loading} onClick={() => { dispatch(setSecPassport({ passportStatus: false })) }}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Update"}</button> : ""
                        }
                    </div>
                </div>
            </div>

            <Modal header="Check Data" onShow={openModal}>
                <div >You haven't filled any data. Do you want to fill joint cust details?</div>
                <div className="d-flex gap-3 mt-4 align-items-center justify-content-center">
                    <button className="btn btn-sm btn-success" onClick={() => setOpenModal(false)}>Yes I want to</button>
                    <button className="btn btn-sm btn-danger" onClick={goToNext}>No I don't want to</button>
                </div>
            </Modal>
            <NextPrev step={6} setStep={setSteps} last={7} onClick={handleNext} loading={loading} />

        </React.Fragment>
    )
}

export default KYC